import React from 'react';
import { Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

export default function MessageInformation({ organization, links = null }) {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Message
            title={t('ticket.transfers.messageMissingBankData.title')}
            type="danger"
            visible
            links={[
                links
                    ? links
                    : {
                          label: t('ticket.transfers.messageMissingBankData.link'),
                          onClick: () => {
                              history.push(`/ticket/O${organization.id}/organization/bank`);
                          }
                      }
            ]}
        >
            <p>{t('ticket.transfers.messageMissingBankData.body')}</p>
        </Message>
    );
}
MessageInformation.propTypes = {
    organization: PropTypes.object.isRequired,
    links: PropTypes.object
};
